import { render, staticRenderFns } from "./taskmine.vue?vue&type=template&id=c4b1d6e2&scoped=true&"
import script from "./taskmine.vue?vue&type=script&lang=js&"
export * from "./taskmine.vue?vue&type=script&lang=js&"
import style0 from "./taskmine.vue?vue&type=style&index=0&id=c4b1d6e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b1d6e2",
  null
  
)

export default component.exports